import styled, { css } from "styled-components";
import React from "react";

const Button = styled.button`
  color: white;
  background: linear-gradient(to right, #a15bff, #ff8a5a) !important;
  padding: 0 20px;
  min-height: 44px;
  border: unset;
  border-radius: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  border-radius: 4px;
  font-weight: 700;
  ${({ outline }) =>
    outline &&
    css`
      border: 1px solid #cb8b28;
      background: white !important;
      color: #cb8b28;
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      background: #2a3045 !important;
      color: #a5bfd7;
    `}
  .dropdown {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(100%);
    z-index: 1;

    ul {
      margin: 8px 0 0;
      background: #212635;
      border-radius: 4px;
      padding: 8px;
    }
    li {
      padding: 10px 8px;
      text-align: start;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 400;
      :hover {
        background: #2a3045;
      }
    }
  }

  :hover {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3), -1px -1px 5px rgba(0, 0, 0, 0.3);
    background: #cb8b28;
    .dropdown {
      display: block;
    }
  }
`;

export default Button;
